import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { Wrapper as Button } from 'components/shared/Button/styles'
import { respondAbove } from 'styles/mediaQueries'
import { colorNames } from 'styles/theme'

interface WrapperProps {
    isAvailableOnline: boolean
    hasDarkMode?: boolean
}

export const Wrapper = styled(Box)<WrapperProps>`
    position: relative;
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    min-height: ${({ isAvailableOnline }) =>
        isAvailableOnline ? '164px' : '142px'};
    border-radius: 8px;
`

interface HeaderWrapperProps {
    hasDarkMode?: boolean
}
export const HeaderWrapper = styled(Box)<HeaderWrapperProps>`
    border-bottom: 2px solid
        ${({ theme, hasDarkMode }) =>
            hasDarkMode
                ? colorNames.grayscale_200
                : theme.colors.grayscale_200};

    @media ${respondAbove.xl} {
        border-bottom: 0 solid ${({ theme }) => theme.colors.grayscale_200};
    }
`

export const PriceColumnWrapper = styled(Box)`
    position: relative;

    & ${Button} {
        width: 102px;

        @media ${respondAbove.xl} {
            width: 116px;
            min-width: unset;
        }
    }
`

export const LabelWrapper = styled(Box)`
    position: absolute;
    top: 8px;
    left: -6px;
    z-index: 1;
    background-color: ${({ theme }) => theme.colors.primary_500};
    padding: 2px 9px;
    border-radius: 2px;
    color: ${({ theme }) => theme.colors.grayscale_0};
    font-size: 8px;

    @media ${respondAbove.xl} {
        padding: 5px 9px;
        left: -8px;
        font-size: 14px;
    }
`

export const PriceWrapper = styled(Box)`
    position: relative;
`

export const OtherPriceWrapper = styled(Text)`
    margin-right: 4px;
    position: absolute;
    top: 0;
    right: 100%;
`

export const LowestPriceWrapper = styled(Text)`
    width: 200px;
    max-width: 55vw;
    margin-top: 4px;
    position: absolute;
    right: 0;
    top: 100%;

    @media ${respondAbove.xl} {
        width: max-content;
        max-width: none;
        margin-top: 15px;
        top: 100%;
    }
`

export const PriceBadge = styled(Text)`
    padding: 3px 8px;
    background-color: ${({ theme }) => theme.colors.primary_100};
    border: 1px solid ${({ theme }) => theme.colors.primary_700};
    border-radius: 2px;

    @media ${respondAbove.xl} {
        padding: 4px 8px;
        border-radius: 4px;
    }
`

export const Image = styled.img`
    border-radius: 6px;
    width: 60px;
    height: 60px;
    flex-shrink: 0;

    @media ${respondAbove.xl} {
        border-radius: 8px 0 0 8px;
        max-width: 182px;
        width: 100%;
        height: auto;
    }
`
